export default __webpack_public_path__ + "b044d4a46493f1a78e68c51e4b243386.png";